angular.module('aprima-provider-api').factory('CalendarRepository',
    ['AprimaRestangular', '$q',
        function (AprimaRestangular, $q) {
            'use strict';

            return {
                getDayTemplate: getDayTemplate,
                getAppointmentOpenSlots: getAppointmentOpenSlots
            };

            function getDayTemplate(calendarId, params) {

                if (calendarId) {
                    return AprimaRestangular.get()
                        .all('calendars/' + calendarId + '/daytemplate')
                        .getList(params);
                }

                return $q.when([]);

            }

            function getAppointmentOpenSlots(search) {
                if(!search) {
                    return $q.when(new Error('search object must be defined'));
                }

                if(!search.calendarId) {
                    return $q.when(new Error('calendarId must be defined'));
                }

                if(!search.date) {
                    return $q.when(new Error('date must be defined'));
                }

                search = {
                    calendarId: search.calendarId,
                    startDate: search.date,
                    appointmentTypeId: search.appointmentTypeId
                };

                return AprimaRestangular.get()
                    .all('calendars').one(search.calendarId).all('opentemplateslots')
                    .getList(search);
            }
        }]);
